// @flow
import React from "react";
import noop from "lodash/noop";
import "./index.css";
import CountBadge from "components/CountBadge";
import Button from "react-bootstrap/lib/Button";
import ButtonGroup from "react-bootstrap/lib/ButtonGroup";
import "font-awesome/css/font-awesome.css";
import FontAwesome from "react-fontawesome";
import { type ToggleItemDTO } from "data/types";
import Constants from "data/constants";
import { getClassNames } from "data/utils";

const renderStatus = (item: ToggleItemDTO) => {
    if (item.status === null || item.status === undefined) return;
    if (item.status === Constants.LOADING)
        return (
            <>
                {" "}
                <FontAwesome className="hidden-xs" name="spinner" pulse />
            </>
        );
    return (
        <>
            {" "}
            <FontAwesome className="hidden-xs" name={item.status} />
        </>
    );
};

type Props = {
    name: string,
    isMultiple: boolean,
    toggles: Array<ToggleItemDTO>,
    onClick: Function,
};

const ToggleBar = ({ name, isMultiple, toggles, onClick }: Props) => (
    <ButtonGroup data-test="toggleButtonGroup" className="tb-btn-group">
        {toggles.map(
            (item: ToggleItemDTO, index: number) =>
                !item.isHidden && (
                    <Button
                        aria-label={item.text}
                        key={index}
                        active={item.isSelected}
                        disabled={item.isDisabled}
                        title={item.text}
                        onClick={() =>
                            item.isDisabled === true /* istanbul ignore next */
                                ? noop
                                : onClick(item, isMultiple)
                        }
                        data-test={`toggleButton-${item.value}`}
                    >
                        {item.icon && <FontAwesome name={item.icon} />}
                        <span
                            className={getClassNames(
                                item.icon
                                    ? "hidden-xs hidden-sm" /* istanbul ignore next */
                                    : "",
                                "text-sm"
                            )}
                        >
                            {" " + item.text}
                        </span>
                        {item.count != null && item.count > 0 && (
                            <span className="text-sm hidden-xs">
                                {" "}
                                <CountBadge count={item.count} />
                            </span>
                        )}
                        {renderStatus(item)}
                    </Button>
                )
        )}
    </ButtonGroup>
);

export default ToggleBar;
